'use client';

import { memo } from 'react';
import PropTypes from 'prop-types';

import useIsBrowser from 'hooks/useIsBrowser';
import useScreen from 'hooks/useScreen';

const MobileOnly = ({ children, fallback = null }) => {
  const isBrowser = useIsBrowser();
  const { isMobile } = useScreen();

  // In new Consumer app, to prevent SSR bug always render on server. After components
  // are mounted in browser, we should conditionally only render when on mobile device.
  return !isBrowser || isMobile ? children : fallback;
};

MobileOnly.propTypes = {
  children: PropTypes.node,
};

export default memo(MobileOnly);
